import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input, Output,
} from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-toggle-text-button",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./toggle-text-button.component.html",
  styleUrl: "./toggle-text-button.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleTextButtonComponent implements AfterContentInit {
  @Output() indexChanged = new EventEmitter<number>();

  @Input() height: "xs" | "sm" | "md" | "lg" | "xl" = "md";
  @HostBinding('class') get classes(): string {
    return `size-${this.height}`;
  }

  _length = 0;
  activeText = "";

  focusDivWeight = "";
  focusDivLeft = "0";
  focusDivTransition = "0";

  _texts!: string[];
  @Input() set texts(value: string[]) {
    this._texts = value;
    this._length = this._texts.length;
    this.focusDivWeight = `calc(((100% - ${this._margin()}px) / ${this._length}) + ${this._margin()}px)`;
  }

  get texts() {
    return this._texts;
  }

  _activeIndex: number | null = null;
  @Input() set activeIndex(value: number) {
    this._indexChanged(value, this._activeIndex === null)
  }
  get activeIndex() {
    return this._activeIndex || 0;
  }

  handleClick(i: number): void {
    this._indexChanged(i, false);
  }

  private _indexChanged(i: number, initialSetup: boolean): void {
    if (this.activeIndex === i) {
      return
    }
    this._activeIndex = i;
    this.activeText = this.texts[i];
    this.indexChanged.emit(i)
    this._adjustLeft(initialSetup);
  }

  ngAfterContentInit(): void {
    this._adjustLeft(true);
  }

  private _adjustLeft(initialSetup: boolean): void {
    this.focusDivTransition = initialSetup ? "left none" : "left 0.5s ease-out";

    if (this.activeIndex === 0) {
      this.focusDivLeft = "0";
    } else {
      this.focusDivLeft = `calc(((100% - ${this._margin()}px) / ${this._length}) * ${this.activeIndex})`;
    }
  }

  private _margin(): number {
    if (this.height === "xs") {
      return 16;
    } else if (this.height === "sm") {
      return 20;
    } else if (this.height === "md") {
      return 24;
    } else if (this.height === "lg") {
      return 28;
    } else {
      //this.height === 'xl'
      return 32;
    }
  }
}
